import Mutations from '../../odata/mutations';

export default { ...new Mutations('integrationSetting'), ...new Mutations('integrationSettings') };
